import linkToAdminPages from "../links";

export default function linkToBrands() {
  return `${linkToAdminPages()}/brands`;
}
